import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCDNAssets, getPointUrl } from '@/utils';
import './index.less';
import { fetchUserInfo } from '@/apis/home';
import type { UserInfo } from '@/apis/home';
import { fetchRightCards } from '@/apis/my';
import type { MemberAssetsItem } from '@/apis/my';
import { MY_ADDRESS, USER_INFO, PROTOCOL, OPTIONS, LOGIN_UNIONPAY, ORDER_LIST } from '@/constants/path';
import { useCookies } from 'react-cookie';
import type { ActionSheetProps } from 'antd-mobile/es/components/action-sheet';
import { ActionSheet } from 'antd-mobile';
const rightArrow: string = getCDNAssets('right_arrow.png');
import { useAppHomeTitle } from '@/hooks/useTitle';
import { trackEvent } from '@/utils/tracker';
import { channelNavigateTo, isDouyinAppChannel } from '@/channels';
import { channelCallPhone } from '@/channels/phone';

type MenuItemType = {
  title: string;
  link: string;
  needLogin?: boolean;
  onlyNotLoggedIn?: boolean;
  isAction?: boolean;
};

const itemList: MenuItemType[] = [
  {
    title: '我的地址',
    link: MY_ADDRESS,
    needLogin: true,
  },
  // {
  //   title: '发票管理',
  //   link: INVOICE,
  // },
  // {
  //   title: '投诉与建议',
  //   link: '',
  // },
  {
    title: '条款与规则',
    link: PROTOCOL,
  },
  {
    title: '设置',
    link: OPTIONS,
  },
  {
    title: '联系客服',
    link: '',
    isAction: true,
  },
];

const douyinItemList: MenuItemType[] = [
  {
    title: '我的订单',
    link: ORDER_LIST,
    needLogin: true,
  },
  {
    title: '我的地址',
    link: MY_ADDRESS,
    needLogin: true,
  },
  {
    title: '我的卡券',
    link: '/cardList/without_login',
    needLogin: false,
    onlyNotLoggedIn: true,
  },
  {
    title: '条款与规则',
    link: PROTOCOL,
  },
  {
    title: '设置',
    link: OPTIONS,
  },
  {
    title: '联系客服',
    link: '',
    isAction: true,
  },
];

const MyPage = () => {
  useAppHomeTitle('我的');
  const navigate = useNavigate();
  const [useInfo, setUseInfo] = useState<UserInfo>();
  const [memberAssets, setMemberAssets] = useState<MemberAssetsItem[]>([]);
  const [availablePoints, setAvailablePoints] = useState('0');
  const [cookie, setCookie] = useCookies<string, { [key: string]: string }>(['sid']);
  const [callVisible, setCallVisible] = useState(false);
  const PHONE_NUMBER = '4009-200-205';
  const handleCallAction = useCallback<NonNullable<ActionSheetProps['onAction']>>((action) => {
    if (action.key === 'call') {
      channelCallPhone(PHONE_NUMBER);
    }
    setCallVisible(false);
  }, []);
  const isLogin = useMemo(() => !!cookie?.sid, [cookie?.sid]);
  const getUserInfo = useCallback(() => {
    fetchUserInfo()
      .then((res) => {
        res && setUseInfo(res);
      })
      .catch((err) => {
        console.info('---getuserinfo err:', err);
        setCookie('sid', '', { path: '/' });
        setUseInfo(undefined);
      });
  }, []);
  const getCards = useCallback(() => {
    fetchRightCards()
      .then((res) => {
        if (res) {
          const { memberAssets: mem = [] } = res;
          if (mem && mem.length) {
            setMemberAssets(mem);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getSubtitle = (item: MemberAssetsItem) => {
    const { subTitle = '', subTitleNum = '' } = item;
    const strs = subTitle.split('$');
    if (strs.length === 1) return <span className="member-item-subTitle">{strs[0]}</span>;
    return (
      <span className="member-item-subTitle">
        {strs[0]}
        {subTitleNum}
        {/* <span className="member-item-subNum">{subTitleNum}</span> */}
        {strs[1]}
      </span>
    );
  };
  const handletoPage = useCallback(
    (url: string) => {
      navigate(url);
    },
    [navigate],
  );
  const handletoH5Page = useCallback(() => {
    const url = getPointUrl();
    if (cookie?.sid) {
      const realUrl = url + '&sid=' + cookie?.sid;
      trackEvent('iconClick', {
        belong_page: '我的',
        module_name: '个人信息',
        rank: 3,
        icon_name: '积分',
        url: realUrl,
      });
      window.location.href = realUrl;
    }
  }, [cookie?.sid]);

  useEffect(() => {
    if (isLogin) {
      getUserInfo();
      getCards();
    }
  }, [isLogin]);

  useEffect(() => {
    if (!useInfo?.availablePoints) return;
    setAvailablePoints(useInfo.availablePoints);
  }, [useInfo]);

  const entryList = useMemo(() => {
    if (isDouyinAppChannel()) {
      return douyinItemList;
    } else {
      return itemList;
    }
  }, [isDouyinAppChannel]);

  return (
    <div className="usercenter">
      {isLogin ? (
        <div className="loginmess">
          <div className="user_login_avatar">
            <div className="left">
              <div className="avatarCon">
                <img src={useInfo?.headImg || 'https://img.mcd.cn/gallery/0fc708ab0912a303.png'} className="avatar" />
              </div>
              <div>
                <div style={{ width: 345 - 204, fontWeight: 'bold' }}>{useInfo?.fullName || '麦麦'}</div>
                <div className="accountcon">
                  <img src="https://img.mcd.cn/gallery/d8701baa9a40fe1f.png" className="core-icon" />
                  <span
                    className="fen"
                    onClick={() => {
                      handletoH5Page();
                    }}>
                    <span className="account">{availablePoints}</span>
                  </span>
                  <img className="account_red_arrow" src={getCDNAssets('red_arrow.png')} />
                </div>
              </div>
            </div>
          </div>
          {memberAssets.length ? (
            <div className="member-panel">
              {memberAssets.map((item, index) => (
                <div
                  className="member-item"
                  key={index}
                  onClick={() => {
                    //测试券跳转
                    // handletoPage(`${CARD_LIST}?filterValue=pickup`);
                    trackEvent('iconClick', {
                      belong_page: '我的',
                      module_name: '会员资产',
                      rank: index + 1,
                      icon_name: item.title,
                      url: item.url,
                    });
                    handletoPage(item.url);
                  }}>
                  <div className="title-wrapper">
                    <span className="member-item-title">{item.title}</span>
                    {getSubtitle(item)}
                  </div>
                  <img src={item.image} />
                </div>
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        <div>
          <div className="pagebg">
            <img className="pagebg-img" src={getCDNAssets('pagebg.png')} />
            <div className="pagemess">
              <span>喜欢您来</span>
              <img className="star" src={getCDNAssets('stardeco.png')} />
            </div>
          </div>
          <div className="loginpanel">
            <span className="mes">周周领专属优惠，新会员首单即享免费圆筒</span>
            <button
              className="login"
              onClick={() => {
                trackEvent('buttonClick', {
                  belong_page: '我的',
                  module_name: '我的（未登录）',
                  button_name: '立即登录',
                });
                if (isDouyinAppChannel()) {
                  channelNavigateTo(
                    `/pages/login/index?redirectUrl=${encodeURIComponent(location.pathname + location.search)}`,
                    { redirect: true },
                  );
                } else {
                  navigate(`${LOGIN_UNIONPAY}?redirectUrl=${encodeURIComponent(location.pathname + location.search)}`);
                }
              }}>
              <div>
                <span>立即登录</span>
              </div>
            </button>
          </div>
        </div>
      )}

      <div className="entry" style={isLogin ? {} : { top: '-20px' }}>
        {entryList.map(
          ({ title, link, needLogin, onlyNotLoggedIn, isAction }) =>
            ((needLogin && isLogin) || (!needLogin && (isLogin ? !onlyNotLoggedIn : true))) && (
              <div
                key={title}
                className="entry-item"
                onClick={() => {
                  trackEvent('buttonClick', {
                    belong_page: '我的',
                    module_name: isLogin ? '我的（已登录）' : '我的（未登录）',
                    button_name: title,
                  });
                  if (isAction) {
                    setCallVisible(true);
                  } else {
                    navigate(link);
                  }
                }}>
                <span>{title}</span>
                <img src={rightArrow} />
              </div>
            ),
        )}
      </div>

      <ActionSheet
        visible={callVisible}
        extra={PHONE_NUMBER}
        cancelText="取消"
        safeArea={false}
        actions={[{ text: '呼叫', key: 'call' }]}
        onClose={() => setCallVisible(false)}
        onAction={handleCallAction}
      />

      {isDouyinAppChannel() && (
        <div
          className="customer-service-btn"
          onClick={() => {
            trackEvent('customerServiceClick', {
              belong_page: '我的',
              button_name: '联系客服',
            });
            channelCallPhone('4009-200-205');
          }}>
          <svg className="icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
              fill="white"
            />
          </svg>
          <span className="text">联系客服</span>
        </div>
      )}
    </div>
  );
};
export default MyPage;
